/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDto } from '../../models/article-dto';
import { ArticleWithIdDto } from '../../models/article-with-id-dto';

export interface ShopInsertArticle$Params {
  'x-trace-id'?: string;
      body: ArticleDto
}

export function shopInsertArticle(http: HttpClient, rootUrl: string, params: ShopInsertArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleWithIdDto>> {
  const rb = new RequestBuilder(rootUrl, shopInsertArticle.PATH, 'post');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleWithIdDto>;
    })
  );
}

shopInsertArticle.PATH = '/api/shop/article';
